import React, { useRef } from 'react';
import { Animated, View } from 'react-native';
import { Headroom, TWCText } from '@components';

import { pictureDetailedVODPageTestIDs, Theme } from '@constants';
import { useContextNodeHandles } from '@hooks';

import { LAYOUT_OFFSET } from './constants';
import { styles } from './styles';

import { PictureDetailedPageHeader } from '../../../components/pictureDetailed/components/PictureDetailedPageHeader';
import { PictureDetailedPageLayout } from '../../../components/pictureDetailed/layout/PictureDetailedPageLayout';

export const PictureDetailedVODContent = ({ data, upNextShow }) => {
  const layoutOffset = useRef(new Animated.Value(LAYOUT_OFFSET)).current;

  const [headerHandle, layoutHandle, readMoreButton, restartButton] = useContextNodeHandles([
    pictureDetailedVODPageTestIDs.headerArea,
    pictureDetailedVODPageTestIDs.seasonsMenu,
    pictureDetailedVODPageTestIDs.readMoreButton,
    pictureDetailedVODPageTestIDs.restartButton,
  ]);

  const headerDownHandle = data?.seasons ? layoutHandle : null;

  return (
    <>
      <Headroom
        duration={350}
        headerComponent={
          <PictureDetailedPageHeader
            data={data}
            nextFocusDown={headerDownHandle}
            nextFocusLeft={headerHandle}
            nextFocusRight={restartButton}
            nextFocusUp={readMoreButton}
            testID={pictureDetailedVODPageTestIDs.headerArea}
            upNextShow={upNextShow}
          />
        }
        headerTestID={'pdpAnimatedWrapper'}
        layoutComponent={
          <PictureDetailedPageLayout
            data={data}
            nextFocusUp={headerHandle}
            testID={pictureDetailedVODPageTestIDs.mainLayout}
            upNextShow={upNextShow}
          />
        }
        layoutOffset={layoutOffset}
        layoutValue={LAYOUT_OFFSET}
        marginValue={Theme.px(10)}
      />
      <View style={styles.title}>
        <TWCText noTestID numberOfLines={1} variant={'pageHeader'}>
          {data?.title}
        </TWCText>
      </View>
    </>
  );
};
